<div><smart-table :options="options" :filters="filters"></smart-table></div>